(function () {
  var STORAGE_KEY = 'mm_wishlist';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
  }

  function isFavorited(handle) {
    return getWishlist().some(function (i) { return i.handle === handle; });
  }

  function toggleFavorite(item) {
    var items = getWishlist();
    var index = items.findIndex(function (i) { return i.handle === item.handle; });
    var nowFavorited;
    if (index >= 0) {
      items.splice(index, 1);
      nowFavorited = false;
    } else {
      items.unshift(item);
      nowFavorited = true;
    }
    saveWishlist(items);
    document.dispatchEvent(new CustomEvent('mm:wishlist:change', { detail: { items: items } }));
    return nowFavorited;
  }

  function removeFavorite(handle) {
    var items = getWishlist().filter(function (i) { return i.handle !== handle; });
    saveWishlist(items);
    document.dispatchEvent(new CustomEvent('mm:wishlist:change', { detail: { items: items } }));
  }

  function updateButtonStates() {
    var items = getWishlist();
    var handles = items.map(function (i) { return i.handle; });
    document.querySelectorAll('.mm-wishlist-btn').forEach(function (btn) {
      var handle = btn.getAttribute('data-product-handle');
      if (handles.indexOf(handle) !== -1) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
      } else {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-pressed', 'false');
      }
    });
  }

  function updateCountBadges() {
    var count = getWishlist().length;
    document.querySelectorAll('.mm-wishlist-count').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function handleClick(e) {
    var btn = e.target.closest('.mm-wishlist-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var item = {
      handle: btn.getAttribute('data-product-handle'),
      title: btn.getAttribute('data-product-title'),
      image: btn.getAttribute('data-product-image'),
      price: btn.getAttribute('data-product-price'),
      url: btn.getAttribute('data-product-url')
    };

    if (!item.handle) return;
    toggleFavorite(item);
  }

  document.addEventListener('click', handleClick);
  document.addEventListener('mm:wishlist:change', function () {
    updateButtonStates();
    updateCountBadges();
  });

  function init() {
    updateButtonStates();
    updateCountBadges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.MMWishlist = {
    get: getWishlist,
    isFavorited: isFavorited,
    toggle: toggleFavorite,
    remove: removeFavorite
  };
})();
